import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { setTurma } from './actions/actions';

const useStyles = makeStyles({
    card: {
        width: 'fit-content'
    },
});

export default function TurmaProfile() {
    const classes = useStyles();
    const turma = useSelector(state => state.turma)
    const dispatch = useDispatch();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <div style={{
                    display: 'flex'
                }}>
                    <div style={{
                        marginRight: '30px'
                    }}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Curso
                        </Typography>
                        <Typography variant="body1" >
                            {turma.curso.abreviacao}
                        </Typography>
                    </div>
                    <div style={{
                        marginRight: '30px'
                    }}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Turma
                        </Typography>
                        <Typography variant="body1" >
                            {turma.descricao}
                        </Typography>
                    </div>
                    <div>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Ano Letivo
                        </Typography>
                        <Typography variant="body1" >
                            {turma.anoLetivo}
                        </Typography>
                    </div>
                </div>

                <CardActions>
                    <Button
                        onClick={() => dispatch(setTurma(null))}
                        size="small"
                        color="secondary"
                        variant="contained"
                    >
                        Trocar Turma
                    </Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}